import React, { Component } from 'react';
import './RollMenu.css';
import * as ellipsisSVG from './ellipsis.svg';

class RollMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false
    };
  }

  toggleMenu() {
    this.setState({
      showMenu: !this.state.showMenu
    })
  }

  clickMenu(e) {
    this.props.onChange(e.target.dataset.value);
    this.setState({
      showMenu: false
    });
  }

  componentDidUpdate(prevProps, prevState) {
    var menu = this.refs.menu;
    if (!menu) {
      return;
    }
    if (menu.getBoundingClientRect().left < 0) {
      menu.style.right = "auto";
    }
    if (menu.getBoundingClientRect().bottom > window.innerHeight) {
      menu.style.bottom = "18px";
    }
  }

  render() {
    var menu = null;
    if (this.state.showMenu) {
      menu = (
        <ul onClick={this.clickMenu.bind(this)} ref="menu">
          <li data-value="line">Line</li>
          <li data-value="clear">Clear Results</li>
          <li data-value="extra">Extra Dice</li>
          <li data-value="caption">Roll Caption</li>
          <li data-value="feedback">App Feedback</li>
        </ul>
      )
    }

    return (
      <div className="rollMenu">
        <button onClick={this.toggleMenu.bind(this)} className="btnSmall">
          <img alt="Options" src={ellipsisSVG} />
        </button>
        {menu}
      </div>
    );
  }
}

export default RollMenu;



// WEBPACK FOOTER //
// ./src/Roller/RollMenu.js